/*
 * phobos-anime.js — zentrale sichtbare Motion-Schicht (anime.js v3).
 * Komponenten: words (Headline-Stagger), weeklyFlip (Local-Termine klappen auf), orbitMeter (Preorder-Orbit),
 * starTrail (Sternspur zum Hero-CTA).
 * Regeln: reduced-motion → aus (statisches Layout bleibt korrekt); ohne
 * anime.js bleibt alles sichtbar; Commerce-Kernstrecke bleibt ruhig.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.PhobosAnime = {
    init: function () {
      this.stepper(); // Wizard-UX auch bei reduced-motion (dann ohne Animation)
      if (reduce || !window.anime) return;
      this.words();
      /* cardDeal drehte Produktkarten beim Erscheinen um ±5°. Die Shop-Welt ist
         laut PRODUCT.md „ruhig, schnell, Motion aus, keine Reveals" — und der
         Kunde will die Drehung ausdrücklich nicht. Deshalb abgeschaltet. */
      this.weeklyFlip();
      this.orbitMeter();
      this.starTrail();
      this.constellation();
      this.hoverPreview();
      this.atcSparkle();
      this.marqueeSkew();
    },

    /* Wort-für-Wort-Enthüllung der Section-Headlines (Zeilen-Maske). */
    words: function () {
      var heads = document.querySelectorAll('main .shead .h1, main .shead .h2, main .shead .display');
      if (!heads.length) return;
      heads.forEach(function (h) {
        if (h.dataset.words) return;
        h.dataset.words = '1';
        var text = h.textContent.trim();
        h.setAttribute('aria-label', text);
        h.innerHTML = text.split(/\s+/).map(function (w) {
          return '<span class="w-line"><span class="w-in">' + w + '</span></span>';
        }).join(' ');
      });
      /* Sicherung: die Zeilenmaske darf nie dauerhaft geschlossen bleiben.
         Bleibt die Animation aus welchem Grund auch immer aus, schneidet sie
         sonst bei erhoehtem Zeilenabstand Text ab (WCAG 1.4.12). */
      setTimeout(function () {
        document.querySelectorAll('.w-line').forEach(function (l) { l.style.overflow = 'visible'; });
      }, 4000);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          anime({
            targets: e.target.querySelectorAll('.w-in'),
            translateY: ['110%', '0%'],
            opacity: [0, 1],
            easing: 'easeOutExpo',
            duration: 850,
            delay: anime.stagger(55),
            /* Die Zeilenmaske darf nur waehrend der Bewegung beschneiden. Bleibt
               sie liegen, schneidet sie bei erhoehtem Zeilenabstand Text ab
               (WCAG 1.4.12). */
            complete: function () {
              e.target.querySelectorAll('.w-line').forEach(function (l) { l.style.overflow = 'visible'; });
            }
          });
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -6% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    },


    /* Local-Termine klappen 3D-gestaffelt auf (Events + Laden). */
    weeklyFlip: function () {
      var rows = document.querySelectorAll('.weekrow');
      rows.forEach(function (row) {
        var slots = row.querySelectorAll('.weekslot');
        if (!slots.length) return;
        row.style.perspective = '900px';
        anime.set(slots, { opacity: 0, rotateX: -58, translateY: 18 });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            anime({
              targets: slots,
              opacity: [0, 1],
              rotateX: [-58, 0],
              translateY: [18, 0],
              easing: 'easeOutExpo',
              duration: 700,
              delay: anime.stagger(85)
            });
          });
        }, { threshold: 0.3 });
        io.observe(row);
      });
    },

    /* Preorder-Orbit: Ring zeichnet sich bis zum Fortschritt; Ziel = Lime-Puls. */
    orbitMeter: function () {
      document.querySelectorAll('[data-orbit]').forEach(function (el) {
        var ring = el.querySelector('.po__fill');
        if (!ring) return;
        var C = parseFloat(ring.getAttribute('data-c'));
        var target = parseFloat(ring.getAttribute('data-target'));
        var reached = el.hasAttribute('data-orbit-reached');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            anime({
              targets: ring,
              strokeDashoffset: [C, target],
              easing: 'easeInOutExpo',
              duration: 1400,
              complete: function () { if (reached) el.classList.add('po--burst'); }
            });
            var num = el.querySelector('[data-orbit-num]');
            if (num) {
              var end = parseInt(num.getAttribute('data-orbit-num'), 10) || 0;
              var obj = { n: 0 };
              anime({
                targets: obj, n: end, round: 1, easing: 'easeInOutExpo', duration: 1400,
                update: function () { num.textContent = obj.n; }
              });
            }
          });
        }, { threshold: 0.4 });
        io.observe(el);
      });
    },

    /* Sternspur vom Portal zum Hero-CTA bei Hover (Desktop). */
    starTrail: function () {
      if (!window.matchMedia('(pointer:fine)').matches) return;
      var btn = document.querySelector('.ph-hero .btn--signal');
      var portal = document.querySelector('[data-portal]');
      if (!btn || !portal) return;
      var last = 0;
      btn.addEventListener('pointerenter', function () {
        var now = Date.now();
        if (now - last < 1400) return;
        last = now;
        var pr = portal.getBoundingClientRect();
        var br = btn.getBoundingClientRect();
        var sx = pr.left + pr.width / 2, sy = pr.top + pr.height / 2;
        var ex = br.left + br.width / 2, ey = br.top + br.height / 2;
        for (var i = 0; i < 6; i++) {
          var s = document.createElement('span');
          s.className = 'star-bit';
          s.style.left = sx + 'px';
          s.style.top = sy + 'px';
          document.body.appendChild(s);
          anime({
            targets: s,
            translateX: (ex - sx) * (0.4 + 0.6 * Math.random()),
            translateY: (ey - sy) * (0.4 + 0.6 * Math.random()) - 30 * Math.random(),
            scale: [1, 0.2],
            opacity: [1, 0],
            easing: 'easeOutExpo',
            duration: 620 + i * 60,
            delay: i * 34,
            complete: (function (node) { return function () { node.remove(); }; })(s)
          });
        }
      });
    },

    /* Hero-Konstellation: Linien zeichnen sich beim Laden. */
    constellation: function () {
      var lines = document.querySelectorAll('.ph-const [data-const]');
      if (!lines.length) return;
      anime({
        targets: lines,
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 1700,
        delay: anime.stagger(420, { start: 400 })
      });
    },

    /* Event-Ticket-Stepper: 3-Schritte-Wizard mit Ticket-Übergängen. */
    stepper: function () {
      var root = document.querySelector('[data-stepper]');
      if (!root) return;
      root.classList.add('stepper--js');
      var panels = {}, dots = {};
      root.querySelectorAll('[data-step-panel]').forEach(function (p) { panels[p.getAttribute('data-step-panel')] = p; });
      root.querySelectorAll('[data-step-dot]').forEach(function (d) { dots[d.getAttribute('data-step-dot')] = d; });
      var cur = '1';
      panels['1'].classList.add('is-on');

      function go(n) {
        if (n === cur) return;
        var from = panels[cur], to = panels[n];
        var show = function () {
          from.classList.remove('is-on');
          to.classList.add('is-on');
          Object.keys(dots).forEach(function (k) {
            dots[k].classList.toggle('is-on', k === n);
            dots[k].classList.toggle('is-done', +k < +n);
          });
          cur = n;
          if (window.anime && !reduce) {
            anime({ targets: to, opacity: [0, 1], translateX: [26, 0], easing: 'easeOutExpo', duration: 380 });
            if (n === '2') {
              anime({
                targets: to.querySelectorAll('.ticket:not(.is-hidden)'),
                opacity: [0, 1], translateY: [22, 0], rotate: [1.5, 0],
                easing: 'easeOutBack', duration: 460, delay: anime.stagger(60)
              });
            }
          }
        };
        if (window.anime && !reduce) {
          anime({ targets: from, opacity: [1, 0], translateX: [0, -18], easing: 'easeInQuad', duration: 160, complete: show });
        } else { show(); }
      }

      root.querySelectorAll('[data-step-game]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-step-game]').forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
          var g = btn.getAttribute('data-step-game');
          root.querySelectorAll('[data-step-ticket]').forEach(function (t) {
            t.classList.toggle('is-hidden', g !== '*' && t.getAttribute('data-game') !== g);
          });
          go('2');
        });
      });
      root.querySelectorAll('[data-step-ticket]').forEach(function (t) {
        t.addEventListener('click', function () {
          var title = root.querySelector('[data-confirm-title]');
          var when = root.querySelector('[data-confirm-when]');
          var cta = root.querySelector('[data-confirm-cta]');
          if (title) title.textContent = t.getAttribute('data-title');
          if (when) when.textContent = t.getAttribute('data-when');
          if (cta && t.getAttribute('data-url')) cta.setAttribute('href', t.getAttribute('data-url'));
          go('3');
        });
      });
      var back = root.querySelector('[data-step-back]');
      if (back) back.addEventListener('click', function () { go('2'); });
    },

    /* Selected Products: Packshot-Preview folgt dem Cursor (Desktop, gelerpt). */
    hoverPreview: function () {
      if (!window.matchMedia('(pointer:fine)').matches) return;
      if (!window.matchMedia('(min-width:900px)').matches) return;
      document.querySelectorAll('[data-selp-row]').forEach(function (row) {
        var prev = row.querySelector('[data-selp-preview]');
        if (!prev) return;
        // Raus aus der Row: die .rv-Reveals hinterlassen einen transform und
        // machen die Row sonst zum Containing Block für position:fixed.
        document.body.appendChild(prev);
        var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
        function tick() {
          cx += (tx - cx) * 0.16; cy += (ty - cy) * 0.16;
          prev.style.setProperty('--px', cx.toFixed(1) + 'px');
          prev.style.setProperty('--py', cy.toFixed(1) + 'px');
          raf = requestAnimationFrame(tick);
        }
        row.addEventListener('pointerenter', function (e) {
          tx = cx = Math.min(e.clientX + 28, window.innerWidth - 240);
          ty = cy = Math.max(12, Math.min(e.clientY - 110, window.innerHeight - 240));
          prev.classList.add('is-on');
          if (!raf) tick();
        });
        row.addEventListener('pointermove', function (e) {
          tx = Math.min(e.clientX + 28, window.innerWidth - 240);
          ty = Math.max(12, Math.min(e.clientY - 110, window.innerHeight - 240));
        });
        row.addEventListener('pointerleave', function () {
          prev.classList.remove('is-on');
          if (raf) { cancelAnimationFrame(raf); raf = null; }
        });
      });
    },

    /* PDP: kurzer Sparkle-Burst am Warenkorb-/Preorder-Button (Commerce-safe). */
    atcSparkle: function () {
      document.querySelectorAll('.pdp2__cta[type="submit"], .satc button[type="submit"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var r = btn.getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          for (var i = 0; i < 8; i++) {
            var s = document.createElement('span');
            s.className = 'star-bit';
            s.style.left = cx + 'px'; s.style.top = cy + 'px';
            document.body.appendChild(s);
            var a = (Math.PI * 2 * i) / 8 + Math.random() * 0.6;
            var d = 34 + Math.random() * 34;
            anime({
              targets: s,
              translateX: Math.cos(a) * d, translateY: Math.sin(a) * d,
              scale: [1, 0], opacity: [1, 0],
              easing: 'easeOutExpo', duration: 480,
              complete: (function (n) { return function () { n.remove(); }; })(s)
            });
          }
        });
      });
    },

    /* Marquee: kippt leicht mit der Scroll-Geschwindigkeit. */
    marqueeSkew: function () {
      var mq = document.querySelector('.marquee');
      if (!mq) return;
      var v = 0;
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () { v = (window.scrollY - lastY); lastY = window.scrollY; }, { passive: true });
      var cur = 0;
      (function loop() {
        var target = Math.max(-8, Math.min(8, v * 0.45));
        cur += (target - cur) * 0.12;
        v *= 0.9;
        mq.style.transform = 'skewX(' + cur.toFixed(2) + 'deg)';
        requestAnimationFrame(loop);
      })();
    }
  };

  if (document.readyState !== 'loading') window.PhobosAnime.init();
  else document.addEventListener('DOMContentLoaded', function () { window.PhobosAnime.init(); });
})();
